import { render, staticRenderFns } from "./list.vue?vue&type=template&id=11454a28&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=11454a28&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11454a28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11454a28')) {
      api.createRecord('11454a28', component.options)
    } else {
      api.reload('11454a28', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=11454a28&scoped=true", function () {
      api.rerender('11454a28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/salesControl/placard/list.vue"
export default component.exports